
import { DropDownActionList, DropDownType } from "../actions/dropDownAction";
import { Action } from "../actions/types";

const initialValue: Array<DropDownType> = [];

const dropdownReducer = (state: Array<DropDownType> = initialValue, action: Action) => {
    switch (action.type) {
        case DropDownActionList.ADD_DROPDOWN:
            return [
                ...state,
                action.data,
            ];

        case DropDownActionList.UPDATE_DROPDOWN:
            const updated = [...state].slice();
            const index = updated.findIndex(u => u.id === action.data.id);

            if (index > -1) {
                updated[index] = {
                    ...action.data,
                };
            }

            return updated;

        case DropDownActionList.FETCH_DROPDOWN:
            return action.data;

        case DropDownActionList.DELETE_DROPDOWN:
            return state.filter(s => s.id !== action.data);

        default:
            return state;
    }
}

export default dropdownReducer;



